/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Snap_To_Event_Start_FailedInputs */

const en_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Snap to event start failed with message: ${i?.error}`)
};

const fr_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alignement sur le début des événements échoué : ${i?.error}`)
};

const de_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Snap zum Starten des Ereignisses fehlgeschlagen mit der Meldung: ${i?.error}`)
};

const it_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scatto all'avvio dell'evento non riuscito con messaggio: ${i?.error}`)
};

const ru_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сбой привязки к началу события с сообщением: ${i?.error}`)
};

const es_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al iniciar el evento de ajuste con el mensaje: ${i?.error}`)
};

const zh_cn2_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`捕捉到事件开始失败，错误信息：${i?.error}`)
};

const ja_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント開始へのスナップが失敗しました。メッセージ: ${i?.error}`)
};

const hi_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्नैप टू इवेंट स्टार्ट विफल रहा, संदेश के साथ: ${i?.error}`)
};

const pt_pt2_snap_to_event_start_failed = /** @type {(inputs: Snap_To_Event_Start_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A sincronização com o início do evento falhou com a mensagem: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Snap to event start failed with message: {error}" |
*
* @param {Snap_To_Event_Start_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_start_failed = /** @type {((inputs: Snap_To_Event_Start_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_Start_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_event_start_failed(inputs)
	if (locale === "de") return de_snap_to_event_start_failed(inputs)
	if (locale === "it") return it_snap_to_event_start_failed(inputs)
	if (locale === "ru") return ru_snap_to_event_start_failed(inputs)
	if (locale === "es") return es_snap_to_event_start_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_event_start_failed(inputs)
	if (locale === "ja") return ja_snap_to_event_start_failed(inputs)
	if (locale === "hi") return hi_snap_to_event_start_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_event_start_failed(inputs)
	return en_snap_to_event_start_failed(inputs)
});